import type { Factory } from 'walden-fast/types/mocks';
import type { NavigationTree } from 'walden-fast/components/sidebar';

const MOCK_NAVIGATION_TREE: NavigationTree = {
  groups: [
    {
      groupName: 'Group Name',
      items: [
        {
          label: 'Item Label',
        },
      ],
    },
  ],
};

export const navigationTreeFactory: Factory<NavigationTree> = (overrides) => ({
  ...MOCK_NAVIGATION_TREE,
  ...overrides,
});
